import { queryOptions, useQuery } from '@tanstack/react-query';

import { storesApi } from '../api/stores-api';

import { storeKeys } from './store-keys';

export function storesQueryOptions() {
  return queryOptions({ queryKey: storeKeys.list(), queryFn: storesApi.list });
}

export function useStores() {
  return useQuery(storesQueryOptions());
}

export function storeQueryOptions(id: string) {
  return queryOptions({ queryKey: storeKeys.detail(id), queryFn: () => storesApi.get(id) });
}

/** `enabled: false` for callers whose role may not read the detail; the query stays idle. */
export function useStoreDetail(id: string, enabled = true) {
  return useQuery({ ...storeQueryOptions(id), enabled });
}
